import React from "react";
import SearchableSelect from "../../../components/common/searchable-select";

const OTHER_BUILDING_VALUE = "other";

const DocumentDeliverySection = ({
  fProps, showErr, formIsDisabled,
  // ── FIX: field กลุ่มข้อมูลผู้ติดต่อ/ปลายทาง (ชื่อ, เบอร์, บริษัท, แผนก, ชั้น) ต้องล็อคเมื่อ status ไม่ใช่ NEW ──
  // ── ต่างจาก formIsDisabled เฉยๆ เพราะสถานะ RETURN ยังแก้ field อื่นในฟอร์มได้ปกติ ──
  // ── default เป็น formIsDisabled เผื่อ caller ไหนไม่ได้ส่ง prop นี้มา จะได้พฤติกรรมเดิม ──
  contactFieldsDisabled = formIsDisabled,
  buildings = [],
  provinces = [],
  districts = [],
  loadingDistricts = false,
  onProvinceChange,
  onBuildingChange,
}) => {
  const buildingField = fProps("receiver_building");
  const provinceField = fProps("receiver_province");
  const districtField = fProps("receiver_district");

  const isOtherBuilding = buildingField.value === OTHER_BUILDING_VALUE;

  const buildingOptions = [
    ...buildings.map((b) => ({ value: String(b.id), label: b.name_th })),
    { value: OTHER_BUILDING_VALUE, label: "อื่นๆ" },
  ];
  const provinceOptions = provinces.map((p) => ({ value: String(p.id), label: p.name_th }));
  const districtOptions = districts.map((d) => ({ value: String(d.id), label: d.name_th }));

  const handleBuildingChange = (e) => {
    const val = e.target.value;
    // set receiver_building ก่อน (ผ่าน onChange เดิมของ fProps)
    buildingField.onChange(e);

    if (!onBuildingChange) return;

    // ถ้าเลือก building จริง (ไม่ใช่ other หรือ empty) → auto-fill จากข้อมูล building
    if (val && val !== OTHER_BUILDING_VALUE) {
      const found = buildings.find((b) => String(b.id) === String(val));
      if (found) {
        onBuildingChange(found);
      }
      return;
    }

    // ── เลือก "อื่นๆ" หรือ clear ค่า (val ว่าง) ──
    // ── ไม่มี building object จริงให้ auto-fill แต่ต้อง clear ค่าเดิม (จังหวัด/เขต/แผนที่/ชั้น) ที่ค้างจาก building ก่อนหน้า ──
    onBuildingChange({});
  };

  return (
    <>
      <hr className="divider" />
      <div className="sub-section-label">Contact Person (ข้อมูลผู้ติดต่อ/ผู้รับเอกสาร)</div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label" htmlFor="receiver_name">
            ชื่อ-สกุล (Name-Surname) <span className="req">*</span>
          </label>
          <input {...fProps("receiver_name")} disabled={contactFieldsDisabled} placeholder="Input" autoComplete="name" />
          {showErr("receiver_name")}
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="receiver_tel">
            เบอร์โทร (Tel.) <span className="req">*</span>
          </label>
          <input {...fProps("receiver_tel")} disabled={contactFieldsDisabled} placeholder="Input" autoComplete="tel" />
          {showErr("receiver_tel")}
        </div>
      </div>

      <hr className="divider" />
      <div className="sub-section-label">Destination Details (ข้อมูลสถานที่จัดส่ง)</div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label" htmlFor="receiver_company">
            บริษัทของจุดหมายปลายทาง Company's destination <span className="req">*</span>
          </label>
          <input {...fProps("receiver_company")} disabled={contactFieldsDisabled} placeholder="Input" />
          {showErr("receiver_company")}
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="receiver_department">
            แผนก Department <span className="req">*</span>
          </label>
          <input {...fProps("receiver_department")} disabled={contactFieldsDisabled} placeholder="Input" autoComplete="new-password" />
          {showErr("receiver_department")}
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label" htmlFor="receiver_building">
            อาคาร Building <span className="req">*</span>
          </label>
          <SearchableSelect
            id="receiver_building"
            name={buildingField.name}
            value={buildingField.value}
            onChange={handleBuildingChange}
            onBlur={buildingField.onBlur}
            disabled={formIsDisabled}
            isInvalid={buildingField.className.includes("is-invalid")}
            options={buildingOptions}
            placeholder="เลือกอาคาร"
          />
          {showErr("receiver_building")}

          {/* ── input กรอกเองเมื่อเลือก อื่นๆ ── */}
          {isOtherBuilding && (
            <div className="form-group" style={{ marginTop: 8 }}>
              <input
                {...fProps("other_building_name")}
                placeholder="ระบุอาคาร"
                autoComplete="off"
              />
            </div>
          )}
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="receiver_floor">
            ชั้น Floor <span className="req">*</span>
          </label>
          <input {...fProps("receiver_floor")} disabled={contactFieldsDisabled} placeholder="Input" autoComplete="new-password" />
          {showErr("receiver_floor")}
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label" htmlFor="receiver_province">
            จังหวัด Province <span className="req">*</span>
          </label>
          <SearchableSelect
            id="receiver_province"
            name={provinceField.name}
            value={provinceField.value}
            onChange={onProvinceChange}
            onBlur={provinceField.onBlur}
            disabled={formIsDisabled || !isOtherBuilding}
            isInvalid={provinceField.className.includes("is-invalid")}
            options={provinceOptions}
            placeholder="เลือกจังหวัด"
          />
          {showErr("receiver_province")}
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="receiver_district">
            เขต District <span className="req">*</span>
          </label>
          <SearchableSelect
            id="receiver_district"
            name={districtField.name}
            value={districtField.value}
            onChange={districtField.onChange}
            onBlur={districtField.onBlur}
            disabled={formIsDisabled || loadingDistricts || !isOtherBuilding}
            isInvalid={districtField.className.includes("is-invalid")}
            options={districtOptions}
            placeholder={loadingDistricts ? "กำลังโหลด..." : "เลือกเขต"}
            noOptionsMessage={loadingDistricts ? "กำลังโหลด..." : "ไม่พบข้อมูล"}
          />
          {showErr("receiver_district")}
        </div>
      </div>

      {/* ── FIX: โชว์ field Google Map เสมอ ไม่ซ่อนแล้ว ── */}
      {/* ── เลือกอาคารจริง (ไม่ใช่ "อื่นๆ") → receiver_map ถูก auto-fill จาก building (onBuildingChange ใน UserRequestDetail.jsx) และล็อคไว้ (read-only) ห้ามแก้เอง ── */}
      {/* ── เลือก "อื่นๆ" → ไม่มี building ให้ auto-fill ต้องปลดล็อคให้กรอกเอง ── */}
      <div className="form-group mb">
        <label className="form-label">Google Map</label>
        <input
          {...fProps("receiver_map")}
          disabled={formIsDisabled || !isOtherBuilding}
          placeholder="Input"
          autoComplete="off"
        />
        {showErr("receiver_map")}
      </div>

      <div className="form-group mb">
        <label className="form-label" htmlFor="note">หมายเหตุ (Remark)</label>
        <textarea {...fProps("note")} placeholder="Type your message here" rows={3} />
      </div>
    </>
  );
};

export default DocumentDeliverySection;